import * as path from "path";
const archiveExtLookup = new Set([
    // Standard archive formats
    ".zip",
    ".7z",
    ".rar",
    ".tar",
    ".gz",
    ".gzip",
    ".tgz",
    ".bz2",
    ".bzip2",
    ".tbz2",
    ".xz",
    ".txz",
    ".lzma",
    ".lzh",
    ".z",
    ".zst",
    ".zstd",
    ".cab",
    ".arj",
    // Split archive parts
    ".z01",
    ".r00",
    ".001",
    // Mod-specific archive formats
    ".fomod",
    ".dazip",
]);
export function knownArchiveExt(filePath) {
    if (filePath == null || filePath.length === 0) {
        return false;
    }
    return archiveExtLookup.has(path.extname(filePath).toLowerCase());
}
/**
 * wrapper around an format-specific archive handler
 *
 * @export
 * @class Archive
 */
export class Archive {
    mHandler;
    constructor(handler) {
        this.mHandler = handler;
    }
    /**
     * list files at the specified path
     */
    get readDir() {
        return this.mHandler.readDir
            ? (archivePath) => this.mHandler.readDir(archivePath)
            : undefined;
    }
    /**
     * read a file at the specified path via a stream
     */
    get readFile() {
        return this.mHandler.readFile
            ? (filePath) => this.mHandler.readFile(filePath)
            : undefined;
    }
    /**
     * extract a single file
     */
    get extractFile() {
        return this.mHandler.extractFile
            ? (filePath, outputPath) => this.mHandler.extractFile(filePath, outputPath)
            : undefined;
    }
    /**
     * extract the entire archive
     */
    get extractAll() {
        return this.mHandler.extractAll
            ? (outputPath) => this.mHandler.extractAll(outputPath)
            : undefined;
    }
    /**
     * create this archive from the files in sourcePath
     */
    get create() {
        return this.mHandler.create
            ? (sourcePath) => this.mHandler.create(sourcePath)
            : undefined;
    }
    /**
     * add a single file to the archive
     */
    get addFile() {
        return this.mHandler.addFile
            ? (filePath, sourcePath) => this.mHandler.addFile(filePath, sourcePath)
            : undefined;
    }
    get write() {
        return this.mHandler.write ? () => this.mHandler.write() : undefined;
    }
}
